/**
 * Nomes das áreas e telas do sistema — fonte única (padrão do menu) — Nexora Grid (frontend).
 *
 * Criado em: 18/10/2026 · Última modificação: 26/10/2026 · Versão: 1.13.0
 *
 * D-010 (decisão do responsável do produto, 18/10/2026): o nome que aparece no menu é o padrão em todo o sistema — barra
 * superior, abas do CCO, títulos das páginas e documentação/treinamento do cliente. Para mudar um nome, mude só aqui.
 */
export const NOMES = {
  cco: "CCO",
  visaoGeral: "Visão geral",
  tendencias: "Tendências",
  alarmes: "Alarmes",
  analise: "Análise por setor",
  relatorios: "Relatórios",  // US-3405: diário, semana, quinzena e mês
  seguranca: "Segurança",
  qualidade: "Qualidade dos sensores",
  gestor: "Gestor",  // US-3403: ronda de 15 min e diagnóstico do gestor
  mapaComando: "Mapa de Comando",  // US-4402: maquete 3D viva da rede (equipamentos, telemetria, agentes e pessoas)
  assistente: "Assistente do CCO",
  scada3d: "SCADA 3D",
  rede: "Rede (simulação)",
  cadastro: "Cadastro de ativos",
  paineis: "Meus painéis",
  treinamento: "Treinamento dos agentes",
  videowall: "Videowall",
  administracao: "Administração",
  usuarios: "Usuários",
  empresas: "Empresas",
  dispositivos: "Dispositivos",
  conectores: "Conectores",
  regras: "Regras de alarme",
  manobraAutomatica: "Manobra automática",
  canais: "Canais e alertas",
  feriados: "Feriados",
  referencias: "Referências oficiais",  // US-3701
  marca: "Marca",  // US-4503
} as const;
